import * as React from 'react';
import Divider from '@mui/material/Divider';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import { styled } from '@mui/material/styles';
import DropDown from './common/dropDown';
import { capitalizeFirst } from './common';
import * as inputId from '../components/common/bookingElementId';
import { paymentModes } from './common/paymentsMode';
import { ABHISHEK_TRAVELS_RATLAM, AM_TOURS_AND_TRAVELS, BHARAT_TOURIST, BLUE_BIRD, DADA_BROTHERS, DASHMESH, DEMO_COMPANY, DNR, GATIMAN_EXPRESS_CARRIERS, GOLINK, JAIN_BABA, JAIN_COMPANY_ID, JAIN_GUDIA, JAIN_NEW, JAIN_PARSHWANTH, KANKAR_ROADWAYS, LAXMI_HOLIDAYS, MAHAVEER, MODI_PARAS, R_S_YADAV, RAJDEEP, RISHABH_COMPANY_ID, RM_LOGISTICS, ROYAL_TRAVEL_AMR, ROYAL_TRAVELS, SHATABDI_BANSWARA, SHREE_LAXMI_YATRA, SHRI_BABU, SRJ_LOGISTICS, STA_COMPANY_ID, STA_RAJKOT_OFFLINE_BRANCH_ID } from '../helper/companyIdhardcode';
import { useAtom, useAtomValue } from 'jotai';
import { CargoRoleRightsAtom, ownCityBranchListAtom } from './common/jotaiState/commonStateAtoms';
import useToken from './helpers/useTokens';
import DropDownOA from './common/dropDownOA'
import { Item } from './common/snippets'
import { useSearchParams } from 'react-router-dom'
import { useTranslation } from '../i18n/I18nProvider'
import { findActivityMeta } from './common/constants'

export function GetActivityUI(val = '', isOnlyDelivery = false,) {
    const [, setSearchParams] = useSearchParams()
    const { translations } = useTranslation()
    const cs = translations.common || {}
    const { loginData } = useToken()
    const [roleRigths] = useAtom(CargoRoleRightsAtom)
    const ownBranchList = useAtomValue(ownCityBranchListAtom)
    const IsOfflineBooking = [
      DEMO_COMPANY,
      MODI_PARAS,
      JAIN_COMPANY_ID,
      JAIN_NEW,
      JAIN_BABA,
      DASHMESH,
      BLUE_BIRD,
      RAJDEEP,
      RISHABH_COMPANY_ID,
      MAHAVEER,
      JAIN_PARSHWANTH,
      RM_LOGISTICS,
      GOLINK,
      SRJ_LOGISTICS,
      AM_TOURS_AND_TRAVELS,
      SHREE_LAXMI_YATRA,
      SHATABDI_BANSWARA,
      BHARAT_TOURIST,
      LAXMI_HOLIDAYS,
      DNR,
      KANKAR_ROADWAYS,
      R_S_YADAV,
      SHRI_BABU,
      ROYAL_TRAVEL_AMR,
      DADA_BROTHERS,
      JAIN_GUDIA,
      GATIMAN_EXPRESS_CARRIERS,
      ABHISHEK_TRAVELS_RATLAM,
    ].includes(loginData.intCompanyID)
    const enableBranchID=[STA_RAJKOT_OFFLINE_BRANCH_ID].includes(loginData.intBranchID)
    let options = []
    const data = roleRigths?.Table?.filter((val, i) => val.Allowed === 1)
    const actvtyOpts = [
    { order: 1, id: 1, key: 'booking', value: cs.booking },
    { order: 2, id: 1, key: 'bookingOffline', value: cs.bookingOffline },
    { order: 3, id: 8, key: 'branchTransfer', value: cs.branchTransfer },
    { order: 4, id: 9, key: 'branchTransferReceive', value: cs.branchTransferReceive },
    { order: 5, id: 3, key: 'dispatchCargo', value: cs.dispatchCargo },
    { order: 6, id: 4, key: 'receive', value: cs.receive },
    { order: 7, id: 6, key: 'delivery', value: cs.delivery },
    { order: 8, id: 6, key: 'deliveryV2Cargo', value: cs.deliveryV2Cargo },
    { order: 9, id: 100, key: 'reports', value: cs.reports },
    { order: 10, id: 102, key: 'admin', value: cs.admin },
    { order: 11, id: 20, key: 'recharge', value: cs.recharge },
    { order: 12, id: 19, key: 'operationsPrivilege', value: cs.operationsPrivilege },
    { order: 13, id: 300, key: 'deliveryMemo', value: cs.deliveryMemo },
    { order: 14, id: 301, key: 'generalSettings', value: cs.generalSettings },
    { order: 15, id: 104, key: 'acountingReports', value: cs.acountingReports },
    { order: 16, id: 105, key: 'BrchUsrMaster', value: cs.BrchUsrMaster },
    { order: 17, id: 106, key: 'dashBoard', value: cs.dashBoard },
    { order: 18, id: 107, key: 'businessAnalysis', value: cs.businessAnalysis },
    { order: 19, id: 200, key: 'mtplMaster', value: cs.mtplMaster },
  ]
    let actOpt = isOnlyDelivery ? actvtyOpts : loginData?.intCompanyID === STA_COMPANY_ID ? actvtyOpts?.filter((obj) => obj.id !== 6) : actvtyOpts?.filter((obj) => obj.key !== 'deliveryV2Cargo')
    const allowOffline =IsOfflineBooking || (loginData?.intCompanyID === STA_COMPANY_ID && enableBranchID)
    actOpt = allowOffline ? actOpt : actOpt.filter((item) => item.key !== 'bookingOffline')
    for (var i = 0; i < actOpt?.length; i++) {
        for (var y = 0; y < data?.length; y++) {
            if (actOpt[i].id === data[y].BookingRightsID) {
                if (data[y]?.BookingRightsID == 1 || data[y]?.BookingRightsID == 6) {
                    const payTypeData = paymentModes.filter((val) => data[y][val.roleRightsId] === 1);
                    if (payTypeData?.length > 0) {
                        options.push(isOnlyDelivery && actOpt[i].key === 'deliveryV2Cargo' ? { ...actOpt[i], value: cs.delivery } : actOpt[i])
                    }
                } else {
                    options.push(isOnlyDelivery && actOpt[i].key === 'deliveryV2Cargo' ? { ...actOpt[i], value: cs.delivery } : actOpt[i])
                }
            }
        }
    }
    if (ownBranchList.length < 2) {
      options = options.filter((option) => !['branchTransfer', 'branchTransferReceive'].includes(option.key))
    }
    const selectedMeta = findActivityMeta(val)
    const selectedOption = options.find((o) => o.key === selectedMeta?.key)
    const selectedLabel = selectedOption
      ? (selectedOption.value === cs.deliveryV2Cargo ? cs.delivery : selectedOption.value)
      : ''
    return (
        <Item sx={{ width: '100%', boxShadow: 'none' }}>
            <DropDownOA
              label={cs.activity}
              data={options}
              width="100%"
              value={capitalizeFirst(selectedLabel)}
              defaultvalue={capitalizeFirst(selectedLabel)}
              searchPlaceholder={'Search Activity'}
              makeAlwaysSelected={true}
              tabIndex="1"
              onSelect={(opt) => {
                setSearchParams({ view: findActivityMeta(opt.key)?.view ?? opt.value })
              }}
              idKey="order"
              dataKey="value"
              id={inputId.activityType}
              disabled={isOnlyDelivery}
              // nextId={['delivery', 'branchTransfer'].includes(selectedMeta?.key) ? '' : inputId.destcity}
              nextId={['delivery', 'branchTransfer'].includes(selectedMeta?.key) ? '' : 'senderCityId'}
            />
        </Item>
    )
}
